import '../App.css';
import React, { useState, useEffect } from 'react';


function TypicalSearchBar({ searchTerm }) {
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        if (searchTerm) {
          setSearchText(searchTerm); 
        }
      }, [searchTerm]);
    
    return (
        <div className="search-container">
            <a href="/" className="typical-logo" style={{display: 'block'}}>Panorama</a>
            <div className="search-input-group">
                <input 
                type="text" 
                className="search-input" 
                value={searchText} 
                onChange={(e) => setSearchText(e.target.value)} 
                />
                <button className="clear-button" onClick={() => setSearchText('')}>
                <i className="fas fa-times"></i>
                </button>
                <button className="search-button">
                <i className="fas fa-search"></i>
                </button>
            </div>
        </div>
    );
  };

export default TypicalSearchBar;